import React, { useEffect, useState } from "react";
import _ from "lodash";

import apiPresets from "../../Services/Api/api-presets";
import DataTable from "../../Components/Table/DataTable";
import etcModule from "../../Modules/etc/etc-module";
import { useNavigate } from "react-router-dom";

const VisitReports = ({ where, columns: propsColumns, onResult }) => {
  const [visits, setVisits] = useState(null);

  const navigate = useNavigate()

  useEffect(() => {
    apiPresets.getVisits({ where }).then((visits) => {
      if (onResult) onResult(visits);

      const processed = visits.map((x, i) => ({
        ...x,
        sl: i + 1,
        schemeName: x.scheme?.name,
        officeName: (x.scheme?.office || x.office)?.name,
        visitorName: x.visitor?.name,

        subdivisionName: (x.scheme?.office || x.office)?.subdivision?.name,
        blockName: (x.scheme?.office || x.office)?.block?.name,
        deptBlockName: (x.scheme?.office || x.office)?.deptBlock?.name,
        circleName: (x.scheme?.office || x.office)?.circle?.name,
        lacName: (x.scheme?.office || x.office)?.lac?.name,

        creationDate: x.creationDate
          ? etcModule?.toViewableDateFormat(x.creationDate)
          : "",

        lastReviewedDate: x.lastReviewedDate
          ? etcModule?.toViewableDateFormat(x.lastReviewedDate)
          : "",

        reportDates: x.reports
          //   ?.filter((x) => x.status !== "pending")
          ?.map((x) =>
            x.lastSubmitDate
              ? etcModule?.toViewableDateFormat(x.lastSubmitDate)
              : "-"
          )
          .join(", "),

        visitStatus: _.startCase(x.status),

        reportStatuses: x.reports
          //   ?.filter((x) => x.status !== "pending")
          ?.map((x) => x.status)
          .join(", "),
      }));

      setVisits(processed);
    });
  }, []);

  const columns = propsColumns || [
    { label: "Sl", accessor: "sl" },
    { label: "Creation Date", accessor: "creationDate" },
    { label: "Visitor", accessor: "visitorName" },

    { label: "Report Date", accessor: "reportDates" },
    { label: "Reviewed At", accessor: "lastReviewedDate" },
    { label: "Report Status", accessor: "reportStatuses" },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        data={visits || []}
        searchable={false}
        emptyList={!visits ? "Loading Data" : null}
        onRowClick={(item) => navigate(`/visit/${item._id}`)}
      />
    </>
  );
};

export default VisitReports;
